varying vec3 vNormal;
varying vec3 vPosition;

//attribute vec2 uv; // Declare UV attribute
varying vec2 vUV;

void main()
{
    vUV = uv; // Assuming uv is the attribute provided by the geometry

    // Position
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    gl_Position = projectionMatrix * viewMatrix * modelPosition;

    // Model normal
    vec3 modelNormal = (modelMatrix * vec4(normal, 0.0)).xyz;

    // Varyings
    vNormal = modelNormal;
    vPosition = modelPosition.xyz;
}